<template>
    <div class="pharmacyrecord">
      <el-row>
        <el-form
          :inline="true"
          :model="filters"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px">
          <el-form-item label="老人姓名" style="margin-left: 30px">
            <el-input
              v-model.trim="filters.oldmanName"
              placeholder="请输入姓名"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="el-icon-search"
              label="查询"
              type="primary"
              @click="findPage"
            />
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <!--表格内容栏-->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :row-style="tableRowStyle"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            prop="oldmanName"
            label="姓名"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="drug"
            label="药品"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="standard"
            label="规格"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="number"
            label="数量"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="usages"
            label="用法"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="beginDate"
            label="开始时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="endDate"
            label="结束时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="state"
            label="状态"
            align="center"
          ></el-table-column>
        </el-table>
      </el-row>
      <el-pagination
        class="fenye"
        background
        layout="total,prev, pager, next"
        :total="total"
        @current-change="changepage"
        align="center"
      ></el-pagination>
    </div>
  </template>
  <script>
  import KtButton from "@/components/KtButton";
  export default {
    name: "MedicalPlanList",
    components: { KtButton },
    data() {
      return {
        loading: true,
        size: "medium", //按钮的尺寸
        tableData: [], //表格数据
        filters: {
          oldmanName: "",
        },
        total: 0, //分页总数
        pageNum: 1,
        pageSize: 10,
      };
    },
    methods: {
      //翻页
      changepage(val) {
        this.pageNum = val;
        this.findPage();
      },
      //enter键查询
      enterSearchMember(e) {
        console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13) {
          this.findPage();
        }
      },
      //查询列表
      findPage(data) {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          oldmanName: this.filters.oldmanName,
          nursingGroupId: sessionStorage.getItem("nursingGroupId"),
        };
        this.$postJson("omc/medicPlan/queryListWithPage", param).then((res) => {
          this.tableData = res.result.list;
          this.total = Number(res.result.total);
          let usagesMap = new Map([
            [1, "一天一次"],
            [2, "一天二次"],
            [3, "一天三次"],
            [4, "一天四次"],
          ]);
          let stateMap = new Map([
            [1, "提交申请"],
            [2, "发布计划"],
            [3, "护工领任务"],
          ]);
          this.tableData = this.tableData.map((element) => {
            element.state = stateMap.get(element.state);
            element.usages = usagesMap.get(element.usages);
            return element;
          });
        });
      },
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      //修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
    },
    created() {},
    mounted() {
      this.findPage();
    },
  };
  </script>
  <style lang="scss" scoped>
  .pharmacyrecord {
    width: 100%;
    min-height: 500px;
    background: #fefefe;
  }
  </style>
  